import React from 'react';
import { CloseBtn, ModalNext as Modal } from 'ha/ui/Modal';
import { makeStyles } from 'tss-react/mui';
import { Coords } from 'google-map-react';
import { LoadableGoogleMap } from 'ha/modules/GoogleMap';
import { ListingMapMarker } from 'ha/components.legacy/Listing/ListingMapMarker';
import { INITIAL_MAP_ZOOM } from '../constants';

const useStyles = makeStyles()({
  container: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: '100%',
  },
  mapCanvas: {
    width: '100%',
    height: '100%',
  },
});

interface Props {
  coordinates: Coords;
  isFullscreenMapOpen: boolean;
  toggleFullscreenMap: () => void;
}
const FullscreenMap: React.FC<Props> = ({
  coordinates,
  isFullscreenMapOpen,
  toggleFullscreenMap,
}) => {
  const { classes } = useStyles();

  return (
    <Modal open={isFullscreenMapOpen} onClose={toggleFullscreenMap}>
      <React.Fragment>
        <div
          className={classes.container}
          data-test-locator="Listing/FullscreenMap"
        >
          <div id="map-canvas" className={classes.mapCanvas}>
            <LoadableGoogleMap
              center={coordinates}
              options={{ scrollwheel: false }}
              zoom={INITIAL_MAP_ZOOM}
            >
              <ListingMapMarker lat={coordinates.lat} lng={coordinates.lng} />
            </LoadableGoogleMap>
          </div>
        </div>
        <CloseBtn kind="mobileMap" onClose={toggleFullscreenMap} />
      </React.Fragment>
    </Modal>
  );
};

export { FullscreenMap };
